import { Config } from '@forgerock/javascript-sdk';
import { getCurrentEnv } from '../hooks/apiUrlResolver';
import authConstants from './authConstants';
import getEssentialsUrl from '../api/config';

const { FR_UI_PORT, AUTH_CLIENT_ID, REALM_PATH, JOURNEY_LOGIN, DEV_PORTAL_PORT, ACTIVITY_SYNC_KEY, SESSION_COOKIE_NAME } = authConstants;

const currentEnv = getCurrentEnv();
export const isLocal = () => window.location.hostname === 'localhost';
const getDomainSuffix = () => window.location.host.toLowerCase().includes('.net') ? '.net' : '.com';
const getFREnvPrefix = () => {
  if (currentEnv === 'prd') return 'prod';
  if (currentEnv === 'qap') return 'qap';
  if (currentEnv === 'qua') return 'qua';
  return 'tst';
};

const getAMUrl = () => 
  `https://login-${getFREnvPrefix()}.availity${getDomainSuffix()}/am`;

const getLoginUrl = () => {
  if (isLocal()) return `http://localhost:${FR_UI_PORT}/#/login`;
  return `${getEssentialsUrl()}/static/public/onb/onboarding-ui-apps/availity-fr-ui/#/login`;
};

export const LOGIN_URL = getLoginUrl();

export const initializeForgeRock = () => {
  const redirectUri = `${getEssentialsUrl()}/static/public/onb/onboarding-ui-apps/availity-fr-ui/callback`;
  
  Config.set({
    clientId: AUTH_CLIENT_ID,
    redirectUri,
    scope: 'openid profile email',
    serverConfig: {
      baseUrl: getAMUrl(),
      timeout: 5000,
    },
    realmPath: REALM_PATH,
    tree: JOURNEY_LOGIN,
  });
};

export const redirectToLogin = (): void => {
  try {
    const isLocalHost = isLocal();
    const safeGotoUrl = isLocalHost
      ? encodeURIComponent(`http://localhost:${DEV_PORTAL_PORT}/#/`)
      : encodeURIComponent(`${window.location.origin}/#/`);
    window.location.href = `${LOGIN_URL}?goto=${safeGotoUrl}`;
  } catch {
    // silently fail
  }
};

export const loginOrRedirect = async (sessionStore: { setIsAuthenticated: (v: boolean | null) => void }): Promise<void> => {
  
  // eslint-disable-next-line unicorn/no-document-cookie
  const hasSessionCookie = document.cookie.includes(SESSION_COOKIE_NAME);

  if (!hasSessionCookie && !isLocal()) {
    redirectToLogin();
    return;
  }
  

  try {
    const { default: sessionApi } = await import('../api/ic/sessionApi');
    const response = await sessionApi.refreshSession();
    if (response?.status === 200 && !(response as { data?: unknown }).data) {
      sessionStore.setIsAuthenticated(true);
      window.location.reload();
      return;
    }
    // 200 with data means session expired — redirect to login
    if (response?.status === 200) {
      redirectToLogin();
    }
  } catch {
    // non-200 or network error — no redirection
  }
};

